export const VALID_PRODUCTION_CHARACTERS = [
	'matt',
	'alejandra',
	'marvin',
	// 'riley',
	'sasha',
	'vikram',
	'lina',
	'petra',
	'zane',
	'david',
	'bernardo',
	'cassidy',
	'maya',
	'marisol',
	'nova',
	'carter',
	'francisco',
	'ani',
];

// create a dictionary of character names to their respective titles
export const CHARACTER_TITLES = {
	matt: 'Giving Feedback on Communication',
	alejandra: 'Practice Communicating an Upcoming Change',
	marvin: 'Giving Feedback on Performance',
	// riley: 'Giving Structured Feedback',
	sasha: 'Practice Performance Coaching',
	vikram: 'Practice a Career Conversation',
	lina: 'Receiving Feedback from Your Manager',
	petra: 'Practicing Re-igniting Engagement',
	zane: 'Coaching for Conflict Resolution',
	david: 'Recieving Feedback from Your Direct Report',
};

// Authoring
export const CONTEXT_AUTHORING_KEY = 'authoring_context';
export const CONTEXT_IS_RANDOMLY_GENERATED_KEY = 'context_is_generated';

export const TIPS_STORAGE_KEY = 'coaching-tips';

export const LJ_HERO_IMAGES_MAP_KEY = 'lj-hero-image-src';

export const DEFAULT_ERROR_SCENARIO =
	"Sorry, we couldn't load your scenario successfully. Please try again later or contact support if the issue persists.";

// Create a dictionary of character names to their respective customized hume congfigurations
export const AUTHORING_HUME_CONFIG_ID = {
	matt: '765bbd8b-1cef-4b4d-9a9f-84c12017972a',
	alejandra: '63bc321e-d916-46e4-92b5-0cfa65d2842b',
	marvin: '26d155b1-2cdc-4e89-9269-7fb337a2d1a6',
	sasha: 'f6f5f97a-351d-4c0a-9b35-051169b8b736',
	vikram: '6eda6187-7af9-4853-a784-a774db91381e',
	lina: '19a0b22d-db6c-49bb-bf18-7d947213c530',
	petra: 'b6fb20c1-eb4a-4ef4-b223-4954290bcda3',
	zane: '32af7e5d-cf70-4ae3-bad4-42b01984fa81',
	david: '630203f7-4d19-4c87-8c0b-144a922e064d',
	bernardo: '5e7c9ec0-e79a-4691-9859-4f80e0a661ed',
	cassidy: '8eb4b328-bf96-4642-bfcf-609407ebad46',
	maya: '10d52078-e863-4f47-8d74-10e29982dbbe',
	marisol: '8a336f18-d632-4ab5-ac97-c3d83978eb6c',
	nova: '81db5ec7-9c34-4241-93d8-920432a1958b',
	carter: '9496fc34-4d5a-4f08-bd8f-46685434f988',
	francisco: '8cd547a4-28c6-4f78-a60c-3365433c4e0c',
	ani: '23815d3c-fd45-4248-84d8-f0b6d719052b',
};

// export const AUTHORING_ORG_ALLOW_LIST = ['Praxis Labs', 'Uber', 'Test Org', 'Amazon'];
// export const COACH_MAYA_ALLOW_LIST = ['Praxis Labs', 'Test Org', 'Torch'];

export const RESUME_CHAT_GROUP_ID = 'resume-chat-group-id';

export const getResumeChatGroupIdKey = (sessionId: string) => `${RESUME_CHAT_GROUP_ID}:${sessionId}`;

export const END_CALL_TOOL_ROLE = 'end_call_tool';

export const HUME_RESUMEDCHAT_DEFAULT_PROMPT = 'Use the <start_the_conversation> section to start the conversation';

// OpenAI Configuration
export const OPENAI_MODEL = 'gpt-4.1-mini';

export const OPENAI_TEXT_STREAM_HEADER = {
	'Content-Type': 'text/plain; charset=utf-8',
	'Cache-Control': 'no-cache, no-transform',
};

export const OPENAI_EVENT_STREAM_HEADER = {
	'Content-Type': 'text/event-stream',
	'Cache-Control': 'no-cache',
	Connection: 'keep-alive',
};

export const STREAM_ERROR_MARKER = '__STREAM_ERROR__';

// Organizations that should receive full coaching reports without streaming
export const NON_STREAMING_ORG_ALLOWLIST = ['Uber', 'Upwork'];
